<h1 class="title">Account Classes</h1>
<h5>&nbsp;</h5>
<acabim-datatable #dataTable [dataSources]="dataSources" hasDetailView="true" (showDetail)="toogleStatus(true)">
</acabim-datatable>
<button class="mt-2 ml-0 cas-button-action" (click)="toogleStatus(true)">ADD</button>
<ng-template [ngIf]="showAddModal">
    <acabim-modal [display]="true" (status)="toogleStatus($event)" [title]="modalTitle">
        <acabim-admin-edit-class [classDetail]="dataSources[0].detailData" (closeModal)="closeModal($event)"></acabim-admin-edit-class>
    </acabim-modal>
</ng-template>
<p-toast position="center"></p-toast>
